<template>
  <div class="login">
    <div class="row">
      <div class="col announce-sec">
        <span class="subtitle">See you at the Business for Good Global Conference <br>in Bali: 2 - 5 Nov 2025</span><br><br>
        <span class="subtitle">
          <a href="https://b1g1.com/conference-2025/" style="color: white;text-decoration:underline !important;" target="_blank">Learn More and Book your Pass </a>
        </span>
        <!-- <span class="title">NEW ENGAGEMENT FEATURE</span><br>
        <span class="subtitle">B1G1’s most exciting update ever</span><br><br>
        <span class="subtitle"><a href="https://blog.b1g1.com/b1g1-engagement-tool/"
                                  style="color: white;text-decoration:underline !important;" target="_blank">Learn more here </a></span> -->
      </div>
      <div class=" col content">
        <div class="login-form-sec">
          <div class="logo">
            <a href="https://www.b1g1.com">
              <link rel="stylesheet" media="all" type="text/css" href="/static/front/font_css.css">
              <img src="/static/logos/logo.png" class="logo-default" alt="alt">
            </a>
          </div>
          <div class="login-content">
            <form v-if="step === 1" @submit.prevent="checkIsEmailVerified">
              <!-- {{passErrValid}} -->
              <div class="alert alert-danger" role="alert"
                   v-if="!passErrValid && display.login_error">{{ display.login_error }}
              </div>
              <div class="alert alert-success" role="alert"
                   v-if="passErrValid && display.login_error">{{ display.login_error }}
              </div>
              <div class="form-group" :class="{'has-error': errors.has('email') }" v-if="!otpSent">
                <label class="control-label visible-ie8 visible-ie9">Username</label>
                <div class="input-icon">
                  <input type="email"  ref="email" name="email" placeholder="Email" v-model="form.username" v-validate="'required|email'" :class="'form-control' + (getError('email') ? ' txterror' : '')" :disabled="otpSent">
                </div>
                <span v-if="errors.has('email') && form.username" class="error">Please enter a valid email address.</span>
              </div>
              <div class="form-group" :class="{'has-error': errors.has('password') }" v-if="!otpSent">
                <label class="control-label visible-ie8 visible-ie9">Password</label>
                <div class="input-icon">
                  <input :type="showPassword ? 'text' : 'password'" ref="password" :disabled="otpSent" name="password" placeholder="Password" v-model="form.password" v-validate="'required'" :class="'form-control' + (getError('password') ? ' txterror' : '')">
                  <img src="/static/images/eye.svg" class="eye-icon" @click="showPassword = !showPassword" v-if="!showPassword" alt="Show Password">
                  <img src="/static/images/eye-off.svg" class="eye-icon" @click="showPassword = !showPassword" v-if="showPassword" alt="Hide Password">
                </div>
              </div>
              <div class="form-actions">
                <!-- <button type="button" id="sendOtpBtn" v-if="!otpSent" class="btn b-btn red-btn"
                        @click="checkIsEmailVerified" :disabled="waiting">
                  <span :disabled="waiting">Login</span>
                </button> -->
                <button type="submit" id="sendOtpBtn" v-if="!otpSent" class="btn b-btn red-btn"
        :disabled="waiting">
  <span :disabled="waiting">Login</span>
</button>
              </div>
              <div class="form-group" v-if="otpSent && $route.query.step == 'verify-otp'" :class="{'has-error': errors.has('otpcode') }">
                <label class="control-label visible-ie8 visible-ie9">Enter OTP</label>
                <input
                  type="text" minlength="4" maxlength="4" ref="otpcode" name="otpcode" id="otpcode" v-model="form.otpcode" placeholder="Enter OTP" pattern="\d*" @keypress="onlyNumbers"  @keypress.enter="entSub(form)" class="otp-input form-control" v-validate="'required'" :class="getError('otpcode') ? 'txterror' : ''"
                />
              </div>
              <div v-if="otpSent" class="form-actions">
                <button type="button" class="btn b-btn red-btn" v-if="otpSent" @click="loginAction" style="float: left;" :disabled="waiting">Login
                </button>
                 <a href="javascript:void(0)" @click="resendOtp">Resend OTP</a>
              </div>
              <div class="row" v-if="!otpSent">
                <div class="dont-sec">
                  <p>Don't have an account?<br><a href="https://www.b1g1.com/businessforgood">Click here</a> to find out
                    more about B1G1.</p>
                </div>
              </div>
              <div class="forget-password" v-if="!otpSent">
                <p class="m-0"><a style="cursor:pointer" @click="showForget()">Forgot your password ?</a></p>
              </div>
            </form>
            <form v-if="step === 2 && !otpSent">
              <div class="alert alert-danger" role="alert" v-if="display.error">{{ display.error }}</div>
              <h5 class="form-title">FORGOT YOUR PASSWORD ?</h5>
              <p>Enter the email that is registered to your account below to reset your password.</p>
              <div class="form-group">
                <div class="input-icon">
                  <input type="email" ref="email" name="email" v-model="form.username" v-validate="'required|email'"
                         class="form-control" placeholder="Email">
                </div>
                <span v-if="errors.count() >0" class="text-danger" style="margin-top: 15px;">Please enter a valid email address.</span>
              </div>
              <div class="form-actions f-btn">
                <a @click="hideForget" class="white-btn float-left">Go to Login </a>
                <button type="button" class="b-btn red-btn" @click="forgetAction()"
                        :disabled="errors.count() >0 || waiting==true">Submit
                </button>
              </div>
              <h6 v-if="display.success" style="margin-top: 20px; font-weight:bold;"><i
                class="fa fa-check"></i> {{ display.success }}</h6>
            </form>
          </div>
          <div class="copyright">B1G1 © {{ new Date().getFullYear() }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store'
import router from '../router'
import userAPI from '../api/user'
import config from '../config/app'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import Cookie from 'vue-js-cookie'
import NotificationMixin from '../helper/mixin/Notification'

Vue.use(VeeValidate)
Vue.use(Cookie)
export default {
  name: 'login',
  data: () => {
    return {
      login_user_id: null,
      showPassword: false,
      form: {
        username: Cookie.get('username') ? Cookie.get('username') : null,
        password: null,
        otpcode: ''
      },
      waiting: false,
      step: 1,
      display: {
        login_error: '',
        error: '',
        success: ''
      },
      intYear: new Date().getFullYear(),
      passErrValid: false,
      otpSent: false
    }
  },
  watch: {
    otpSent (newValue) {
      const currentQuery = { ...this.$route.query }
      if (newValue) {
        currentQuery.step = 'verify-otp'
      } else {
        delete currentQuery.step
      }
      this.$router.replace({ query: currentQuery }).catch((err) =>
        console.warn('Router replace error:', err)
      )
    }
  },
  mixins: [NotificationMixin],
  created () {
    // wants to check commit from other component
    let param = store.getters.currentUser
    if (param != null) {
      router.push('/impact')
    }
    if (this.$store.getters.getMessage) {
      this.bToast('success', this.$store.getters.getMessage)
      setTimeout(() => {
        this.$store.commit('setMessage', '')
      }, 5000)
    }
    if (this.$route && this.$route.query && this.$route.query.step === 'verify-otp') {
      if (!this.otpSent) {
        this.$router.replace({ path: '/login', query: {} })
      } else {
        this.otpSent = true
      }
    }
  },
  methods: {
    onlyNumbers (event) {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault()
      }
    },
    checkIsEmailVerified () {
      this.$validator.validateAll('form').then((result) => {
        if (!result) {
          return
        }
        this.waiting = true
        const payload = {
          username: this.form.username || null,
          password: this.form.password || null
        }
        userAPI.checkEmailVerified(payload)
          .then((response) => {
            if (response.status === 'success') {
              if (response.data.is_verified === 'yes') {
                this.sendOtp()
              } else {
                this.loginAction(false)
              }
            } else if (response.status === 'error') {
              this.waiting = false
              this.display.login_error = response.message
              setTimeout(() => {
                this.display.login_error = ''
              }, 3000)
            }
          })
          .catch((error) => {
            console.error('API Error:', error)
            this.waiting = false
          })
      })
    },
    sendOtp () {
      this.$validator.validateAll('form').then((result) => {
        if (!result) {
          return
        }
        this.waiting = true
        const payload = {
          username: this.form.username || null,
          password: this.form.password || null
        }
        userAPI.sendOtp(payload)
          .then((response) => {
            if (response.status === 'success') {
              this.otpSent = true
              this.passErrValid = true
              this.display.login_error = response.message
              this.login_user_id = response.data.user_id
              setTimeout(() => {
                this.display.login_error = ''
              }, 3000)
              this.$validator.reset()
            } else if (response.status === 'error') {
              this.display.login_error = response.message
              setTimeout(() => {
                this.display.login_error = ''
              }, 3000)
            }
          })
          .catch((error) => {
            console.error('API Error:', error)
          })
          .finally(() => {
            this.waiting = false
          })
      })
    },
    resendOtp () {
      if (!this.otpSent || !this.login_user_id) {
        console.warn('OTP has not been sent yet or user ID is missing. Cannot resend.')
        return
      }
      this.waiting = true
      const payload = {
        user_id: this.login_user_id
      }
      userAPI.resendOtp(payload)
        .then((response) => {
          if (response.status === 'success') {
            this.passErrValid = true
            this.otpSent = true
            this.display.login_error = response.message
            setTimeout(() => {
              this.display.login_error = ''
            }, 3000)
          } else if (response.status === 'error') {
            this.passErrValid = false
            this.display.login_error = response.message
            setTimeout(() => {
              this.display.login_error = ''
            }, 3000)
          }
          this.waiting = false
        })
        .catch((error) => {
          console.error('API Error:', error)
          this.waiting = false
          if (error.response) {
            const status = error.response.status
            if (status === 404) {
              // this.bToast('error', 'User not found')
            } else if (status === 401) {
              // this.bToast('error', 'Invalid credentials')
            } else if (status === 500) {
              // this.bToast('error', 'Server error: ' + error.response.data.error)
            } else {
              // this.bToast('error', 'Something went wrong. Please try again.')
            }
          } else {
            // this.bToast('error', 'Network error. Please check your connection.')
          }
        })
        .finally(() => {
          this.waiting = false // Stop loading
        })
    },
    getError (name) {
      return this.errors.items.filter(i => i.field === name).length > 0
    },
    loginAction (otpRequired = true) {
      this.$validator.validateAll('form').then((result) => {
        this.waiting = true
        if (!otpRequired) {
          if (localStorage.getItem('fp_token')) {
            localStorage.removeItem('fp_token')
          }
          this.$store.dispatch('login', this.form).then(() => {
            this.saveUserLogin(this.form.username, this.form.password)
          }).catch(() => {
            this.waiting = false
            this.display.login_error = 'Wrong credentials'
            setTimeout(() => {
              this.display.login_error = ''
            }, 3000)
          })
          return
        }
        if (!this.form.otpcode) {
          this.$nextTick(() => {
            const otpInput = document.getElementById('otpcode')
            if (otpInput) {
              otpInput.classList.add('txterror')
            }
          })
          return
        }
        if (!result) {
          return
        }
        const payload = {
          user_id: this.login_user_id,
          otp: this.form.otpcode
        }
        userAPI.verifyOtp(payload)
          .then((response) => {
            if (response.status === 'success') {
              this.passErrValid = true
              this.display.login_error = response.message
              setTimeout(() => {
                this.display.login_error = ''
              }, 3000)
              Cookie.set('username', this.form.username)
              this.waiting = true
              if (localStorage.getItem('fp_token')) {
                localStorage.removeItem('fp_token')
              }
              this.$store.dispatch('login', this.form).then(() => {
                this.saveUserLogin(this.form.username, this.form.password)
              }).catch(() => {
                this.waiting = false
                this.display.login_error = 'Wrong credentials'
                setTimeout(() => {
                  this.display.login_error = ''
                }, 3000)
              })
            } else {
              this.waiting = false
              this.passErrValid = false
              this.display.login_error = response.message
              setTimeout(() => {
                this.display.login_error = ''
              }, 3000)
            }
          })
          .catch((error) => {
            this.waiting = false
            this.passErrValid = false
            if (error.response) {
              this.display.login_error = error.response.data.message
            } else {
              this.display.login_error = 'OTP verification failed. Please try again.'
            }
            setTimeout(() => {
              this.display.login_error = ''
            }, 3000)
          })
      })
    },
    // loginAction () {
    //   this.$validator.validateAll('form').then((result) => {
    //     if (!this.form.otpcode) {
    //       this.$nextTick(() => {
    //         const otpInput = document.getElementById('otpcode')
    //         if (otpInput) {
    //           otpInput.classList.add('txterror')
    //         }
    //       })
    //       return
    //     }
    //     if (!result) {
    //       return
    //     }
    //     const payload = {
    //       user_id: this.login_user_id,
    //       otp: this.form.otpcode
    //     }
    //     // Step 1: Call Verify OTP API
    //     userAPI.verifyOtp(payload)
    //       .then((response) => {
    //         console.log('API Response:', response)

    //         if (response.status === 'success') {
    //           this.passErrValid = true
    //           this.display.login_error = response.message
    //           setTimeout(() => {
    //             this.display.login_error = ''
    //           }, 3000)
    //           // Step 2: OTP verified, proceed with login
    //           Cookie.set('username', this.form.username)
    //           this.waiting = true
    //           if (localStorage.getItem('fp_token')) {
    //             localStorage.removeItem('fp_token')
    //           }
    //           this.$store.dispatch('login', this.form).then(() => {
    //             this.saveUserLogin(this.form.username, this.form.password)
    //           }).catch(() => {
    //             this.waiting = false
    //             this.display.login_error = 'Wrong credentials'
    //             setTimeout(() => {
    //               this.display.login_error = ''
    //             }, 3000)
    //           })
    //         } else {
    //           // If API response has status 'error'
    //           this.passErrValid = false
    //           this.display.login_error = response.message
    //           setTimeout(() => {
    //             this.display.login_error = ''
    //           }, 3000)
    //         }
    //       })
    //       .catch((error) => {
    //         this.passErrValid = false
    //         console.log('API Error:', error)
    //         if (error.response) {
    //           this.display.login_error = error.response.data.message
    //         } else {
    //           this.display.login_error = 'OTP verification failed. Please try again.'
    //         }
    //         setTimeout(() => {
    //           this.display.login_error = ''
    //         }, 3000)
    //       })
    //   })
    // },
    entSub (form) {
      if (window.event && window.event.which === 13) {
        this.loginAction()
      } else {
        return true
      }
    },
    saveUserLogin (username, password) {
      let reloadUrl = localStorage.getItem('b1g1_reload_url')
      userAPI.saveUserLogin(username).then((response) => {
        this.waiting = false
        if (response.status === 'error') {
          this.display.login_error = response.error_msg
          this.$store.dispatch('logout')
        } else {
          if (response.user_type === 'business') {
            localStorage.setItem('b1g1_reload_url', '')
            if (reloadUrl === '' || reloadUrl === null) {
              let segments = window.location.pathname.split('/')
              if (segments[1] === 'login' || segments[1] === 'businessforgood') {
                location.href = config.host + '/impact'
              } else {
                window.location.reload()
              }
            } else {
              location.href = reloadUrl
            }
          } else if (response.user_type === 'partner') {
            localStorage.removeItem('login_user_type')
            location.href = config.host + '/'
          } else {
            if (response.user_type === 'admin') {
              localStorage.setItem('login_user_type', 'admin')
              localStorage.setItem('YUJAqQWVZTRRJsvPpKIG', btoa(username))
              localStorage.setItem('VxdqRJrxxGTZSSwFmmOU', btoa(password))
              localStorage.setItem('b1g1_reload_url', '')
            }
            location.href = config.host + '/'
          }
        }
      }, () => {
        this.waiting = false
      })
    },
    showForget () {
      this.step = 2
    },
    hideForget () {
      this.step = 1
    },
    forgetAction () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        this.waiting = true
        userAPI.resetPassword(this.form.username).then((response) => {
          if (response.error) {
            this.waiting = false
            this.step = 2
            this.passErrValid = false
            this.display.success = ''
            if (response.error === '1') {
              this.display.error = 'An error has occurred. Please reach out to us at hello@b1g1.com and we\'ll get you sorted.'
            } else if (response.error === '2') {
              this.display.error = 'This account has been suspended. Please reach out to team@b1g1.com for help with your account.'
            }
          } else {
            this.waiting = false
            this.step = 2
            this.passErrValid = true
            this.display.success = 'A link to reset your password has been sent to your email address.'
            this.display.error = ''
          }
        }, () => {
          this.waiting = false
          this.step = 2
          this.display.success = ''
          this.display.error = 'Email does not exists.'
        })
      })
      return true
    }
  },
  mounted () {
    let fpToken = localStorage.getItem('fp_token')
    if (fpToken) {
      this.display.login_error = 'The password reset link has expired. Please request another one to reset your password.'
      localStorage.removeItem('fp_token')
    }
    if (!Cookie.get('username')) {
      this.$refs.email.focus()
    } else {
      this.$refs.password.focus()
    }
  }
}
</script>

<style scoped>
.input-icon {
  position: relative;
  display: block;
}
body {
  font-family: 'Brandon Grotesque';
  font-style: normal;
  font-size: 14px;
  font-weight: 300;
}

a {
  text-decoration: none !important;
  font-family: 'Brandon Grotesque';
  font-style: normal;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Brandon Grotesque';
  letter-spacing: 1.2px;
}

.login {
  height: 100%;
  min-height: 100vh;
  position: relative;
}
.login:after {
    content: "";
    height: 100%;
    min-height: 100vh;
    background-image: url(/static/front/images/conference-login-blocks.jpg);
    background-size: cover;
    position: absolute;
    left: 0;
    top: 0;
    width: 50%;
    z-index: -1;
}
.row {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.login .logo {
  margin: 0 auto;
  text-align: center;
  padding: 5px 35px;
  left: 50%;
}

.logo-default {
  width: 150px;
}

.login .content {
  background: #47BFEE;
  height: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login .login-content {
  background: #FFFFFF;
  box-shadow: 0px 20px 53px rgba(0, 0, 0, 0.28);
  margin: 0 auto;
  padding: 18px;
  width: 350px;
}

.login-content form {
  padding: 12px;
}

.form-actions {
  text-align: right !important;
}

.login .copyright {
  text-align: center;
  margin: 35px 0px;
  color: #FFFFFF;
  font-size: 14px;
}

.login .content span.error {
  color: #b94a48;
}
.btn:hover {
  color: #fefefe;
  text-decoration: none;
}

.forget-password a {
  color: #47BFEE;
  text-decoration: underline !important;
}

.login-content [type="email"], .login-content [type="password"] {
  border: 1px solid #000000;
  height: 35px;
  width: 100%;
  padding: 0px 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  border-radius: 0;
  font-size: 14px;
}

.login-content label {
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 0px;
}

.dont-sec {
  padding-top: 20px;
}

.login-content h5 {
  font-size: 18px;
  text-align: center;
  margin-bottom: 19px;
}

.form-actions.f-btn {
  margin-top: 20px !important;
}

.red-btn {
  background: #FF1254;
  border-radius: 3px !important;
}

.b-btn {
  color: #fff;
  padding: 5px 14px;
  display: inline-block;
  font-weight: 600;
  text-transform: uppercase;
  border: 0;
  font-size: 14px;
  cursor: pointer;
}

.white-btn {
  padding: 5px 14px;
  display: inline-block;
  font-weight: 600;
  text-transform: uppercase;
  border: 1px solid #ddd;
  color: #000000;
  background: #fff;
  cursor: pointer;
  border-radius: 3px !important;
}

.white-btn:hover {
  border: 1px solid #000000;
  color: #fff !important;
  background: #000000;
}

.txterror {
  border: 1px solid red !important;
}

.btn, button {
  border-radius: 0 !important;
}
img.eye-icon {
  width: 20px;
  position: absolute;
  top: 17px;
  right: 10px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.announce-sec {
  margin: auto;
  text-align: center;
}

.title {
  color: white;
  font-size: 1.82em;
  font-family: 'Brandon Grotesque';
  letter-spacing: 1.2px;
}

.subtitle {
  font-family: 'Brandon Grotesque';
  font-weight: lighter;
}

.subtitle {
  color: white;
  font-size: 1.5em;
  letter-spacing: 1.2px;
}

@media screen and (max-width: 1000px) {

  .announce-sec {
    display: none;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue